module.exports = __webpack_public_path__ + "img/icon-info.2e2e2ffc.svg";